import React, {useEffect, useState} from "react";

import PageContainer from "../../layouts/PageContainer";
import {helpers} from '../../helper/helper';
import {useCallback} from "react";
import UsersLists from "./UserLists";
import Loader from "../../layouts/Loader";

const GiveAway = () => {
    const [userList, setUserList] = useState();
    const [skip, setSkip] = useState(1);
    const [limit, setLimit] = useState(10);
    const [filterText, setFilterText] = useState("");
    const [loading, setLoading] = React.useState(false);
    const UsersData = useCallback(async (skip, limit, search) => {
        setLoading(true);
        const url = `users?skip=${skip}&limit=${limit}&search=${search}`;
        const result = await helpers.apiCall('GET', url);
        setUserList(result.data);
        setLoading(false);
    }, [setUserList]);

    useEffect(() => {
        UsersData(skip, limit, filterText);
    }, [UsersData, skip, limit, filterText]);

    return (
        <PageContainer pageheading="GIVE AWAY">
            {!userList || loading ? <div style={{ display: "flex", width: "100%", height: "60vh", justifyContent: "center", alignItems: "center" }}>
                <div className="spinner-border" style={{ color: "#F85476" }} role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div> :
                <UsersLists userList={userList} 
                skip={skip}
                setSkip={setSkip}
                limit={limit}
                setLimit={setLimit} 
                filterText={filterText}
                setFilterText={setFilterText} />
            }
        </PageContainer>
    )
};

export default GiveAway;